import { Component } from '@angular/core';
import { DsModalColorVariant, DsModalService, Icons, DsColors } from '@levelaccess/design-system';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-vertical-navigation-modal',
  templateUrl: './vertical-navigation-modal.component.html',
  styleUrls: ['./vertical-navigation-modal.component.scss'],
  standalone: false,
})
export class VerticalNavigationModalComponent {
  protected readonly Icons: typeof Icons = Icons;
  protected readonly DsModalColorVariant: typeof DsModalColorVariant = DsModalColorVariant;
  protected readonly DsColors: typeof DsColors = DsColors;

  constructor(
    public modalService: DsModalService,
    public modal: NgbActiveModal,
  ) {}

  public onMenuItemClick(): void {
    this.modal.close();
  }
}
